import type { StripeElementsOptions } from '@stripe/stripe-js';

import type { ThemeMode } from '@/hooks/useResolvedTheme';

export function buildStripeAppearance(theme: ThemeMode): StripeElementsOptions['appearance'] {
  return theme === 'dark'
    ? {
        theme: 'night',
        variables: {
          colorPrimary: '#ffffff',
          colorBackground: '#0f0f0f',
          colorText: '#f1f5f9',
          colorTextSecondary: '#9ca3af',
          colorDanger: '#f87171',
          fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
          spacingUnit: '4px',
          borderRadius: '8px',
        },
        rules: {
          '.Input': {
            backgroundColor: '#0b0b0b',
            border: '1px solid #2a2a2a',
            boxShadow: 'none',
          },
          '.Input:focus': {
            border: '1px solid #4b5563',
            boxShadow: '0 0 0 1px #4b5563',
          },
          '.Label': {
            color: '#e5e7eb',
          },
          '.Tab': {
            backgroundColor: '#111111',
            border: '1px solid #2a2a2a',
          },
          '.Tab--selected': {
            backgroundColor: '#1f1f1f',
            borderColor: '#4b5563',
          },
          '.Block': {
            backgroundColor: '#0f0f0f',
            border: '1px solid #2a2a2a',
          },
        },
      }
    : {
        theme: 'stripe',
        variables: {
          colorPrimary: '#111827',
          colorBackground: '#ffffff',
          colorText: '#111827',
          colorTextSecondary: '#6b7280',
          colorDanger: '#dc2626',
          fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
          spacingUnit: '4px',
          borderRadius: '8px',
        },
        rules: {
          '.Input': {
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            boxShadow: 'none',
          },
          '.Input:focus': {
            border: '1px solid #9ca3af',
            boxShadow: '0 0 0 1px #9ca3af',
          },
          '.Label': {
            color: '#111827',
          },
          '.Tab': {
            backgroundColor: '#f9fafb',
            border: '1px solid #e5e7eb',
          },
          '.Tab--selected': {
            backgroundColor: '#ffffff',
            borderColor: '#9ca3af',
          },
          '.Block': {
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
          },
        },
      };
}

